import { CTAButton } from "../styles/common/CTAButton.styled"
import { AboutContent, DarkCircle, GradientCircle, ImageContainer, StyledAboutSection, StyledEmoji, StyledHeading, StyledImage } from "../styles/sections/AboutSection.styled"

export const AboutSection = () => {
    return(
        <>
        <StyledAboutSection id="about">
            <ImageContainer>
                <StyledImage src="./images/profile.jpg" alt="Christian Price"/>
                <DarkCircle/>
                <GradientCircle/>
            </ImageContainer>
            <AboutContent>
                <StyledHeading>
                    Hello <StyledEmoji>👋</StyledEmoji>
                </StyledHeading>
                <p> I am a web developer specializing in React, React Three Fiber, WordPress, and Blender models. 
                    I create custom websites that are fast, responsive, and provide an excellent user experience. 
                    My expertise in these technologies enables me to create stunning 3D graphics and animations that 
                    can be incorporated into your website. With my skills and experience, I can design and develop a 
                    website that meets your specific needs. Contact me to discuss your project and how I can help you achieve your goals.</p>
                <p> Check me out!</p>
                <CTAButton href="#" target="_blank">
                    Get Portfolio📚
                </CTAButton>
            </AboutContent>
        </StyledAboutSection>
        <hr/>
        </>
    )
}